module.exports = __webpack_public_path__ + "img/bg7.6b84e109.png";